import { useCallback } from 'react';
import produce from 'immer'
import { useReactFlow, useStoreApi } from 'reactflow'
// import { useParams } from 'next/navigation'
import {
  useStore,
  useWorkflowStore,
} from '../store';
import { BlockEnum } from '../types'
// import { useWorkflowUpdate } from '../hooks'
import { useNodesReadOnly } from './use-workflow';
// import { syncWorkflowDraft } from '@/service/workflow'
// import { useFeaturesStore } from '@/app/components/base/features/hooks'
// import { API_PREFIX } from '@/config'
  import { message } from 'antd'
  // @ts-ignore
  import useHTTP from "@/hooks/useHTTP.mjs";
  // @ts-ignore
  import runAsync from "@/script/runAsync.mjs";
  import { sortNodesWithMultipleSources } from '../utils'

/** @name 自动保存 */
export const useNodesSyncDraft = () => {
  const store = useStoreApi()
  const http = useHTTP()
  const { fitView } = useReactFlow();
  const workflowStore = useWorkflowStore()
  // const featuresStore = useFeaturesStore()
  const { getNodesReadOnly } = useNodesReadOnly();
  // const { handleRefreshWorkflowDraft } = useWorkflowUpdate()
  const debouncedSyncWorkflowDraft = useStore(
    (s) => s.debouncedSyncWorkflowDraft,
  );
  // const params = useParams()

  const getPostParams = useCallback(() => {
    const {
      getNodes,
      edges,
      transform,
    } = store.getState()
    const [x, y, zoom] = transform
    const {
      prjData,
      conversationVariables,
      // environmentVariables,
      // syncWorkflowDraftHash,
    } = workflowStore.getState()

    if (prjData.pkid) {
      const nodes = getNodes()
      const hasStartNode = nodes.find(node => node.data.type === BlockEnum.Start)

      if (!hasStartNode)
        return

      // const features = featuresStore!.getState().features
      const producedNodes = produce(nodes, (draft) => {
        draft.forEach((node) => {
          Object.keys(node.data).forEach((key) => {
            if (key.startsWith('_') || key === 'selected')
              delete node.data[key]
          })
        })
      })
      const producedEdges = produce(edges, (draft) => {
        draft.forEach((edge) => {
          edge.selected = false;
          Object.keys(edge.data).forEach((key) => {
            if (key.startsWith('_'))
              delete edge.data[key]
          })
        })
      })
      const sortNodes = sortNodesWithMultipleSources(producedNodes, producedEdges)

      return {
        // url: `/apps/${appId}/workflows/draft`,
        ...prjData,
        wfMap: JSON.stringify({
          graph: {
            nodes: sortNodes,
            edges: producedEdges,
            viewport: {
              x,
              y,
              zoom,
            },
          },
        }),
      };
    }
  }, [store, workflowStore])

  /* const syncWorkflowDraftWhenPageClose = useCallback(() => {
    if (getNodesReadOnly())
      return
    const postParams = getPostParams()

    if (postParams) {
      navigator.sendBeacon(
        `${API_PREFIX}/apps/${params.appId}/workflows/draft?_token=${localStorage.getItem('console_token')}`,
        JSON.stringify(postParams.params),
      )
    }
  }, [getPostParams, params.appId, getNodesReadOnly]) */

  /* const doSyncWorkflowDraft = useCallback(async (
    notRefreshWhenSyncError?: boolean,
    callback?: {
      onSuccess?: () => void
      onError?: () => void
      onSettled?: () => void
    },
  ) => {
    if (getNodesReadOnly())
      return
    const postParams = getPostParams()

    if (postParams) {
      const {
        setSyncWorkflowDraftHash,
        setDraftUpdatedAt,
      } = workflowStore.getState()
      try {
        const res = await syncWorkflowDraft(postParams)
        setSyncWorkflowDraftHash(res.hash)
        setDraftUpdatedAt(res.updated_at)
        callback?.onSuccess && callback.onSuccess()
      }
      catch (error: any) {
        if (error && error.json && !error.bodyUsed) {
          error.json().then((err: any) => {
            if (err.code === 'draft_workflow_not_sync' && !notRefreshWhenSyncError)
              handleRefreshWorkflowDraft()
          })
        }
        callback?.onError && callback.onError()
      }
      finally {
        callback?.onSettled && callback.onSettled()
      }
    }
  }, [workflowStore, getPostParams, getNodesReadOnly, handleRefreshWorkflowDraft]) */

  const handleSyncWorkflowDraft = useCallback(
    (
      sync?: boolean,
      notRefreshWhenSyncError?: boolean,
      callback?: {
        onSuccess?: () => void;
        onError?: () => void;
        onSettled?: () => void;
      },
    ) => {
      if (getNodesReadOnly()) return;

      // if (sync) doSyncWorkflowDraft(notRefreshWhenSyncError, callback);
      // else debouncedSyncWorkflowDraft(doSyncWorkflowDraft);
    },
    [debouncedSyncWorkflowDraft, getNodesReadOnly],
  );

  const handleSyncWorkflowSave = useCallback(async() => {
      if (getNodesReadOnly()) return;
      const parms = getPostParams();
      try {
        let saveUrl = '/modifyBmBfWfMap';
  
        const data = await runAsync(
          async () => {
              return await http.post(saveUrl, parms);
          }, {
          action: '保存',
          error: { content: (err) => `保存失败: ${err.message}` },
          loading: { show: true },
          success: { show: true },
        });
      } catch (error) {
        console.log('保存失败')
      }
    },
    [debouncedSyncWorkflowDraft, getNodesReadOnly]
  )

  const handleSyncWorkflowUpdate = useCallback(async() => {
      const {
        prjData,
      } = workflowStore.getState()
      const parms = {
        pkid: prjData.pkid,
      }
      try {
        const data = await runAsync(
          async () => {
              return await http.post('/bmbfs/wfGenScene', parms);
          }, {
          action: '更新制品',
          error: { content: (err) => `失败: ${err.message}` },
          loading: { show: true },
          success: { show: true },
        });
      } catch (error) {
        console.log('更新制品失败')
      }
    },
    [workflowStore]
  )

  return {
    getPostParams,
    // doSyncWorkflowDraft,
    handleSyncWorkflowDraft,
    // syncWorkflowDraftWhenPageClose,
    handleSyncWorkflowSave,
    handleSyncWorkflowUpdate
  };
};
